import dynamic from 'next/dynamic';

// Portas de entrada dos itens de idioma nos menus dos modelos (22/10/2026). Carregamento sob demanda:
// os ~300 sites sem o seletor não baixam o código (o ponto de chamada já está atrás de temSeletorIdiomas).
// - Linha "Idioma" do painel/gaveta: só existe com o menu aberto (depois de um clique) → sem SSR.
// - Item "Idioma" da barra do computador: visível ao carregar → com SSR (sem salto no cabeçalho).
export const IdiomasMenu = dynamic(() => import('./IdiomasMenu'), { ssr: false });
export const IdiomaNavItem = dynamic(() => import('./IdiomaNavItem'), { ssr: true });
